import HOME_PHONE from "../constants/lib/homePhone";

/**
 * Formats a numeric amount as a locale-aware currency string.
 * Falls back to a plain "{CURRENCY} {amount}" string if the
 * Intl API rejects the given currency code.
 */
export const formatCurrency = (
  amount: number,
  currency: string = HOME_PHONE.FALLBACK_CURRENCY,
): string => {
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
    }).format(amount);
  } catch {
    return `${currency} ${amount.toFixed(2)}`;
  }
};
